const C = {
  name: "Cash",
  dimensions: { width: 40, height: 24 },
  content: `
    <g fill="currentColor" stroke="none">
      <path d="M38 22H3C2.45 22 2 21.55 2 21V2H37C37.55 2 38 2.45 38 3V22ZM38 0H2C0.9 0 0 0.9 0 2V22C0 23.1 0.9 24 2 24H38C39.1 24 40 23.1 40 22V2C40 0.9 39.1 0 38 0Z"/>
      <path d="M18.91 8.13999C21.95 7.32999 24.66 10.04 23.85 13.08C23.5 14.42 22.42 15.5 21.08 15.85C18.04 16.66 15.33 13.95 16.13 10.91C16.5 9.57999 17.58 8.49999 18.91 8.13999ZM18.63 17.85C23 18.83 26.83 15 25.85 10.63C25.36 8.42999 23.58 6.64999 21.38 6.15999C17 5.17999 13.18 8.99999 14.15 13.37C14.65 15.58 16.42 17.35 18.63 17.85Z"/>
      <path d="M9 19C9 18.45 8.55 18 8 18H6V16C6 15.45 5.55 15 5 15C4.45 15 4 15.45 4 16V19C4 19.55 4.45 20 5 20H8C8.55 20 9 19.55 9 19Z"/>
      <path d="M5 9C5.55 9 6 8.55 6 8V6H8C8.55 6 9 5.55 9 5C9 4.45 8.55 4 8 4H4V8C4 8.55 4.45 9 5 9Z"/>
      <path d="M32 6H34V8C34 8.55 34.45 9 35 9C35.55 9 36 8.55 36 8V5C36 4.45 35.55 4 35 4H32C31.45 4 31 4.45 31 5C31 5.55 31.45 6 32 6Z"/>
      <path d="M32 20H36V16C36 15.45 35.55 15 35 15C34.45 15 34 15.45 34 16V18H32C31.45 18 31 18.45 31 19C31 19.55 31.45 20 32 20Z"/>
    </g>
  `
};
export {
  C as Cash
};
